const COPY_FEEDBACK_TIMEOUT = 2000

// Общие кнопки копирования: текст лежит в data-copy-text. Обработчик один на
// документ — работают и кнопки из подгруженной разметки (окно брони в ЛК).
export function initCopyButtons() {
  document.addEventListener('click', async (event) => {
    const button = (event.target as Element).closest<HTMLButtonElement>(
      'button[data-copy-text]'
    )
    const text = button?.dataset.copyText
    if (!button || !text) return

    try {
      await navigator.clipboard.writeText(text)
      // innerHTML, а не textContent: вместе с надписью вернётся иконка.
      const original = button.innerHTML
      button.textContent = 'Скопировано'
      button.disabled = true
      setTimeout(() => {
        button.innerHTML = original
        button.disabled = false
      }, COPY_FEEDBACK_TIMEOUT)
    } catch {
      // eslint-disable-next-line no-alert -- фолбэк, когда Clipboard API недоступен (http/старый браузер)
      window.prompt('Скопируйте текст вручную:', text)
    }
  })
}
